var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"bg-variant":"light","header":"Experiment reports","header-bg-variant":"dark","header-text-variant":"white"}},[_c('experiment_list',{attrs:{"elevated":false,"load_data_url":_vm.url,"prop_fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }